import { ArnNftContext } from './ArnNftContext';
import { ArnNftService } from './ArnNftService';
import { ArnHttpService } from '../http';
import { ArnAuthService } from '../auth';
import { ArnValidNftConfig } from '@arianee/arn-types';
import { ArnContextualizable } from '../ArnContextualizable';
import { ArnLogger } from '../log';

export interface ArnInternalNftService extends ArnNftService {
  log: ArnLogger;
  http: ArnHttpService;
  auth: ArnAuthService;
  config: ArnValidNftConfig;
}

export class ArnDelegateNftService
  implements ArnContextualizable<ArnNftContext>
{
  constructor(protected service: ArnInternalNftService) {}

  protected get http(): ArnHttpService {
    return this.service.http;
  }

  protected get auth(): ArnAuthService {
    return this.service.auth;
  }

  protected get config(): ArnValidNftConfig {
    return this.service.config;
  }

  protected get log(): ArnLogger {
    return this.service.log;
  }

  inContext(context: ArnNftContext | undefined): this {
    this.service.inContext(context);
    return this;
  }

  get context(): ArnNftContext | undefined {
    return this.service.context;
  }
}
